const navs = document.getElementsByClassName("header__menu-item");
let megaMenu = null;
let menu = null;

// add class "active" to element on button press
Object.values(navs).forEach(nav => {
    nav.addEventListener("click", function() {
        if(this.getAttribute('aria-expanded') === "true"){
            megaMenu = nav.nextElementSibling;
            menu = nav;
            document.body.classList.add("body-background-gray");
        }
        });
});

// Detect click outside the big menu to close the gray zone of the body
window.addEventListener('click', function(e){
    let menuOpen = false;
    Object.values(navs).forEach(nav => {
            if(nav.getAttribute('aria-expanded') === "true"){
                menuOpen = true;
            }
    });
    if(!menuOpen ){
        document.body.classList.remove("body-background-gray");
    }
});

// Add a keypress event listener to the document
document.addEventListener('keyup', function(event) {
    // Check if the pressed key is within the input element
    const searchInput = document.getElementById("Search-In-Modal-1");

    if (event.target === searchInput) {
        window.checkInputSearchValue();
    }
  });

window.checkInputSearchValue = function() {
    const searchInput = document.getElementById("Search-In-Modal-1");

    const inputValue = searchInput.value;

    // Display the value in the console (you can do something else with the value)
    const labelInputs = document.getElementsByClassName("header__search--label");

    if(!labelInputs) {
        return;
    }
    const label = labelInputs[0];
    if(inputValue !== ""){
      label.style.display = 'none';
    }
    else {
      label.style.display = "block";
    }
};

document.addEventListener('DOMContentLoaded', window.checkInputSearchValue);
